import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'
import uz from './locales/uz.json'

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('admin_language') || 'en'

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
    uz,
  },
})

export default i18n

// Helper function to change language
export function setLanguage(lang: string) {
  if (['en', 'ru', 'uz'].includes(lang)) {
    i18n.global.locale.value = lang as 'en' | 'ru' | 'uz'
    localStorage.setItem('admin_language', lang)
  }
}

// Helper function to get current language
export function getCurrentLanguage(): string {
  return i18n.global.locale.value
}
